import { getService } from 'data/function';
export class UnauthorizedAccessProcessor {
    static get $state() {
        return getService('$state');
    }
    static get ngToast() {
        return getService('ngToast');
    }
    static get $translate() {
        return getService('$translate');
    }
    static async process() {
        const errorMsg67 = await UnauthorizedAccessProcessor.$translate('utils.errorMsg.67');
        UnauthorizedAccessProcessor.ngToast.danger(errorMsg67);
        UnauthorizedAccessProcessor.$state.go('auth.application.list');
    }
}
